// src/utils/micPermission.js
export async function debugMicEnvironment() {
  const info = {
    hasMediaDevices: !!navigator.mediaDevices,
    permissionState: 'unknown',
    devices: [],
  }

  try {
    if (navigator.permissions?.query) {
      const status = await navigator.permissions.query({ name: 'microphone' })
      info.permissionState = status.state // 'granted' | 'denied' | 'prompt'
    }
  } catch {
    info.permissionState = 'unsupported'
  }

  try {
    const list = await navigator.mediaDevices?.enumerateDevices?.()
    info.devices = (list || []).map(d => ({
      kind: d.kind,
      label: d.label || '(no label)',
      deviceId: d.deviceId,
    }))
  } catch (e) {
    info.devicesError = String(e?.message || e)
  }

  // eslint-disable-next-line no-console
  console.table(info.devices)
  // eslint-disable-next-line no-console
  console.log('[Mic debug]', info)
  return info
}

export async function ensureMicrophonePermission() {
  if (!navigator.mediaDevices?.getUserMedia) {
    throw new Error('This browser does not support microphone access (getUserMedia).')
  }

  // Observe current state (if available). If it's 'denied', Chrome will auto-deny without prompting.
  try {
    if (navigator.permissions?.query) {
      const status = await navigator.permissions.query({ name: 'microphone' })
      if (status.state === 'denied') {
        throw new Error(
          'Microphone access is blocked for this site. Click the camera icon in the address bar and set Microphone to “Allow”, then reload.'
        )
      }
    }
  } catch {
    // ignore; permissions API not always available
  }

  // Actively request mic to trigger the prompt when not blocked.
  // Using a generic constraint helps some drivers.
  let stream
  try {
    stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true } })
  } catch (err) {
    // Normalize common cases
    const name = err?.name || ''
    if (name === 'NotAllowedError' || name === 'SecurityError') {
      throw new Error(
        'Microphone permission denied. Use the address-bar camera icon → Allow, then reload.'
      )
    }
    if (name === 'NotFoundError' || name === 'OverconstrainedError') {
      throw new Error('No microphone input device found. Plug in or enable a mic and try again.')
    }
    throw new Error(`Unable to access microphone: ${err?.message || String(err)}`)
  } finally {
    try {
      stream?.getTracks?.().forEach(t => t.stop())
    } catch {
      // ignore — best-effort cleanup of mic stream tracks
    }
  }

  return true
}
